export default __webpack_public_path__ + "static/media/about-icon.9054598b.svg";